export enum EquipmentType {
  Cable = 'Cables',
}

export enum EquipmentTypeId {
  Cable = '79f7fae5-0448-4752-a8e2-5d93f7912c8a',
}
